import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { BiCalendar } from "react-icons/bi";
import { FcDocument, FcOrganization } from "react-icons/fc";
import styled from "styled-components";
import BranchBillingNote from "../backoffice/b0101-branch-billing-note";

export const DefaultEditorValue = { show: false, action: () => {} };
export const _iconColor = "var(--icon-fore)";
export default function AdminMonthlyWork() {
  const [billingNote, setBillingNote] = useState(DefaultEditorValue);

  const showBillingNote = (value) =>
    setBillingNote((pv) => ({ ...pv, show: value }));

  return (
    <DivMain>
      <DivContainter>
        <SpanBigLabel>
          <BiCalendar
            size={30}
            color={_iconColor}
            style={{ marginInline: "10px" }}
          />
          รายการงานประจำเดือน
        </SpanBigLabel>
      </DivContainter>
      <DivContainter style={{ backgroundColor: "var(--x-bg-text-input)" }}>
        <GetBlackCard
          buttonTitle="เปิด"
          text="วางบิลประจำเดือน"
          onClick={() => showBillingNote(true)}
        >
          <FcDocument size={120} />
        </GetBlackCard>
      </DivContainter>
      <BranchBillingNote {...{ list: [billingNote, setBillingNote] }} />
    </DivMain>
  );
}

export const DivMain = styled.div`
  display: flex;
  min-height: 50%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const DivContainter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  /* background: var(--x-bg-primary); */
  width: 100%;
  padding: 30px;
  border-radius: 5px;
  flex-wrap: wrap;
`;

export const SpanBigLabel = styled.span`
  font-size: 20px;
  color: var(--caption-fore-color);
`;

export const BlackCard = styled(Card)`
  background-color: var(--bg-primary);
  border: none;
  color: var(--fore-primary);
  :hover {
    /* border: 1px solid red; */
    background-color: var(--bg-secondary);
  }
`;

export const GetBlackCard = (props) => {
  const { title, buttonTitle, text, onClick, children } = props;
  return (
    <BlackCard style={{ margin: "5px" }}>
      <Card.Body
        onClick={onClick}
        style={{ flex: "1", cursor: "pointer", minWidth: "200px" }}
      >
        <Card.Title
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <LiaUserTieSolid size={120} /> */}
          {children}
        </Card.Title>
        <Card.Text
          style={{
            display: "flex",
            justifyContent: "center",
            color: "var(--caption-fore-color)",
          }}
        >
          {text}
        </Card.Text>
      </Card.Body>
      {/* <ButtonMenu onClick={onClick}>{buttonTitle}</ButtonMenu> */}
    </BlackCard>
  );
};
